// removed by extract-text-webpack-plugin
module.exports = {"overflow-ellipsis":"style__overflow-ellipsis___EQtIU","base-text":"style__base-text___3Dsxi","large-text":"style__large-text___1gM7-","chart--header":"style__chart--header___be2yt","larger-text":"style__larger-text___x6v6g","largest-text":"style__largest-text___37dzA","stats":"style__stats___3_UKD","chart--container":"style__chart--container___2Jb66"};


//////////////////
// WEBPACK FOOTER
// ./components/StatsList/style.scss
// module id = 1302
// module chunks = 0